import type { PreviewProduct } from "./searchPreviewData";

/** Lightweight product illustrations for the explicitly labeled sample catalog. */
export default function PreviewProductImage({ kind }: { kind: PreviewProduct["image"] }) {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 130" role="img" aria-label={`${kind === "air" ? "Air filter" : kind === "oil" ? "Oil filter" : kind === "pads" ? "Brake pads" : "Brake rotor"} illustration`}>
        <ellipse cx="100" cy="115" rx="58" ry="7" fill="#dfe3e5" />
        {kind === "rotor" && <g transform="translate(100 62) rotate(-18)">
            <circle r="49" fill="#b8c0c6" stroke="#717e88" strokeWidth="3" />
            <circle r="39" fill="none" stroke="#e7edf0" strokeWidth="9" />
            <circle r="23" fill="#606e78" stroke="#8898a4" strokeWidth="8" />
            <circle r="12" fill="#f6f7f8" />
            {Array.from({ length: 12 }, (_, i) => <circle key={i} cx={35 * Math.cos(i * Math.PI / 6)} cy={35 * Math.sin(i * Math.PI / 6)} r="2.5" fill="#74818b" />)}
            {Array.from({ length: 5 }, (_, i) => <circle key={i} cx={19 * Math.cos(i * Math.PI * 2 / 5)} cy={19 * Math.sin(i * Math.PI * 2 / 5)} r="3" fill="#d5dfe4" />)}
        </g>}
        {kind === "pads" && [0, 1].map(i => <g key={i} transform={`translate(${36 + i * 24} ${24 + i * 40}) rotate(-12 50 20)`}>
            <path d="M0 12 Q8 0 22 0 H82 Q96 0 100 12 V38 H0Z" fill="#61707b" stroke="#414b53" strokeWidth="2" />
            <path d="M10 12 Q15 7 24 7 H79 Q88 7 90 13 V31 H10Z" fill="#363d43" />
            <path d="M50 7 V31" stroke="#809099" strokeWidth="3" />
        </g>)}
        {kind === "air" && <g transform="translate(45 17) rotate(-10 55 45)">
            <rect width="110" height="90" rx="8" fill="#d07441" stroke="#8d452e" strokeWidth="3" />
            <rect x="9" y="9" width="92" height="72" rx="3" fill="#f2e1b9" />
            {Array.from({ length: 15 }, (_, i) => <path key={i} d={`M${14 + i * 5.4} 10 V80`} stroke="#c4ab80" strokeWidth="2" />)}
        </g>}
        {kind === "oil" && <g transform="translate(62 20) rotate(12 38 45)">
            <path d="M0 12 Q38 -4 76 12 V82 Q38 101 0 82Z" fill="#366e9a" stroke="#234d6f" strokeWidth="2" />
            <path d="M10 22 V79" stroke="#6398bd" strokeWidth="7" />
            <ellipse cx="38" cy="12" rx="38" ry="12" fill="#c4ccd1" stroke="#6b7b88" strokeWidth="2" />
            <ellipse cx="38" cy="12" rx="11" ry="5" fill="#526471" />
            <rect x="23" y="35" width="37" height="29" rx="2" fill="#ecf0f2" />
            <path d="M28 44 H53 M28 50 H48 M28 56 H53" stroke="#74838d" strokeWidth="2" />
        </g>}
    </svg>;
}
